"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeZerIdFromEinBn = exports.toDeZerEinBn = exports.isDeZerIdValid = exports.DE_ZER_EIN_BN_PREFIX = exports.areDeFiscalFieldsFormatValid = exports.areDeTaxExemptionFieldsRequired = exports.getDeTaxOfficeDisplayName = exports.isDeReceiptFreeTextValid = exports.DE_CHARITABLE_PURPOSE_MAX_LENGTH = exports.DE_SIGNATORY_NAME_MAX_LENGTH = exports.hasDeReceiptFields = exports.isDeLegalFormEligibleForReceipt = exports.DE_LEGAL_FORMS_WITHOUT_RECEIPT_SUPPORT = exports.getPreselectedDeTaxStatus = exports.isDeExemptionCertificateDateValid = exports.validateDeExemptionCertificateDate = exports.parseDateOnlyStringAsLocalDate = exports.isDeFinanzamtValid = exports.normalizeDeSteuernummer = exports.isDeSteuernummerValid = exports.formatDeRegisterNumberForStripe = exports.normalizeDeVereinsregisternummer = exports.isDeVereinsregisternummerValid = exports.isDePostalCodeValid = exports.usesDeFiscalFields = exports.DE_EXEMPTION_CERTIFICATE_MAX_AGE_IN_YEARS = exports.isDeRegisterNumberValid = exports.getDeRegisterCourtUpdate = exports.normalizeDeRegisterCourtForStorage = exports.hasDeRegisterCourt = exports.getDeRegisterType = exports.DE_LEGAL_FORMS = exports.DeLegalForm = void 0;
const enums_1 = require("../../enums");
const country_1 = require("../enums/country");
var DeLegalForm;
(function (DeLegalForm) {
    DeLegalForm["EingetragenerVerein"] = "EingetragenerVerein";
    DeLegalForm["Ggmbh"] = "Ggmbh";
    DeLegalForm["Gug"] = "Gug";
    DeLegalForm["Stiftung"] = "Stiftung";
    DeLegalForm["Genossenschaft"] = "Genossenschaft";
    DeLegalForm["KoerperschaftDesOeffentlichenRechts"] = "KoerperschaftDesOeffentlichenRechts";
})(DeLegalForm || (exports.DeLegalForm = DeLegalForm = {}));
exports.DE_LEGAL_FORMS = Object.values(DeLegalForm);
const DE_REGISTER_TYPES = {
    [DeLegalForm.EingetragenerVerein]: "VR",
    [DeLegalForm.Ggmbh]: "HRB",
    [DeLegalForm.Gug]: "HRB",
    [DeLegalForm.Genossenschaft]: "GnR",
    [DeLegalForm.Stiftung]: undefined,
    [DeLegalForm.KoerperschaftDesOeffentlichenRechts]: undefined,
};
const getDeRegisterType = (legalForm) => legalForm ? DE_REGISTER_TYPES[legalForm] : "VR";
exports.getDeRegisterType = getDeRegisterType;
const hasDeRegisterCourt = (legalForm) => {
    const registerType = (0, exports.getDeRegisterType)(legalForm);
    return registerType === "HRB" || registerType === "GnR";
};
exports.hasDeRegisterCourt = hasDeRegisterCourt;
const normalizeDeRegisterCourtForStorage = (registerCourt, legalForm) => ((0, exports.hasDeRegisterCourt)(legalForm) ? registerCourt?.trim() || null : null);
exports.normalizeDeRegisterCourtForStorage = normalizeDeRegisterCourtForStorage;
const getDeRegisterCourtUpdate = (registerCourt, legalForm) => registerCourt === undefined && (0, exports.hasDeRegisterCourt)(legalForm)
    ? {}
    : { deRegisterCourt: (0, exports.normalizeDeRegisterCourtForStorage)(registerCourt, legalForm) };
exports.getDeRegisterCourtUpdate = getDeRegisterCourtUpdate;
const isDeRegisterNumberValid = (registerNumber, legalForm) => {
    const registerType = (0, exports.getDeRegisterType)(legalForm);
    if (!registerType || !registerNumber) {
        return true;
    }
    return new RegExp(`^(${registerType.toUpperCase()}\\s?)?\\d{1,6}(\\s?[A-Z]{1,2})?$`).test(registerNumber.trim().toUpperCase());
};
exports.isDeRegisterNumberValid = isDeRegisterNumberValid;
exports.DE_EXEMPTION_CERTIFICATE_MAX_AGE_IN_YEARS = 5;
const usesDeFiscalFields = (country) => country === country_1.OrganizationCountry.Germany;
exports.usesDeFiscalFields = usesDeFiscalFields;
const isDePostalCodeValid = (postalCode) => {
    if (!postalCode) {
        return true;
    }
    return /^\d{5}$/.test(postalCode.trim());
};
exports.isDePostalCodeValid = isDePostalCodeValid;
const isDeVereinsregisternummerValid = (registerNumber) => (0, exports.isDeRegisterNumberValid)(registerNumber, DeLegalForm.EingetragenerVerein);
exports.isDeVereinsregisternummerValid = isDeVereinsregisternummerValid;
const normalizeDeVereinsregisternummer = (registerNumber) => registerNumber?.trim().toUpperCase().replace(/\s/g, "") ?? registerNumber;
exports.normalizeDeVereinsregisternummer = normalizeDeVereinsregisternummer;
const formatDeRegisterNumberForStripe = (registerNumber) => {
    if (!registerNumber) {
        return undefined;
    }
    const match = /^([A-Z]{2,3})\s?(\d{2,10})\s?([A-Z]{1,2})?$/.exec(registerNumber.trim().toUpperCase());
    if (!match) {
        return undefined;
    }
    const [, registerType, individualNumber, suffix] = match;
    return [registerType, individualNumber, suffix].filter(Boolean).join(" ");
};
exports.formatDeRegisterNumberForStripe = formatDeRegisterNumberForStripe;
const isDeSteuernummerValid = (taxNumber) => {
    if (!taxNumber) {
        return true;
    }
    const digits = taxNumber.replace(/[\s/]/g, "");
    if (!/^\d+$/.test(digits)) {
        return false;
    }
    return digits.length === 10 || digits.length === 11 || digits.length === 13;
};
exports.isDeSteuernummerValid = isDeSteuernummerValid;
const normalizeDeSteuernummer = (taxNumber) => taxNumber ? taxNumber.replace(/[\s/]/g, "") : taxNumber;
exports.normalizeDeSteuernummer = normalizeDeSteuernummer;
const isDeFinanzamtValid = (taxOffice) => {
    if (!taxOffice) {
        return true;
    }
    return taxOffice.trim().length >= 3;
};
exports.isDeFinanzamtValid = isDeFinanzamtValid;
const DATE_ONLY_TIMEZONE_GRACE_IN_MS = 24 * 60 * 60 * 1000;
const parseDateOnlyStringAsLocalDate = (value) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
    if (!match) {
        return new Date(NaN);
    }
    const [, year, month, day] = match;
    return new Date(Number(year), Number(month) - 1, Number(day));
};
exports.parseDateOnlyStringAsLocalDate = parseDateOnlyStringAsLocalDate;
const validateDeExemptionCertificateDate = (date, now = new Date()) => {
    if (!date) {
        return undefined;
    }
    if (Number.isNaN(date.getTime())) {
        return "invalid";
    }
    if (date.getTime() > now.getTime() + DATE_ONLY_TIMEZONE_GRACE_IN_MS) {
        return "inFuture";
    }
    const oldestAllowedDate = new Date(now.getTime() - DATE_ONLY_TIMEZONE_GRACE_IN_MS);
    oldestAllowedDate.setFullYear(oldestAllowedDate.getFullYear() - exports.DE_EXEMPTION_CERTIFICATE_MAX_AGE_IN_YEARS);
    if (date.getTime() < oldestAllowedDate.getTime()) {
        return "expired";
    }
    return undefined;
};
exports.validateDeExemptionCertificateDate = validateDeExemptionCertificateDate;
const isDeExemptionCertificateDateValid = (date, now = new Date()) => (0, exports.validateDeExemptionCertificateDate)(date, now) === undefined;
exports.isDeExemptionCertificateDateValid = isDeExemptionCertificateDateValid;
const getPreselectedDeTaxStatus = (legalForm) => {
    if (legalForm === DeLegalForm.Ggmbh || legalForm === DeLegalForm.Gug) {
        return enums_1.OrganizationType.Charity;
    }
    return undefined;
};
exports.getPreselectedDeTaxStatus = getPreselectedDeTaxStatus;
exports.DE_LEGAL_FORMS_WITHOUT_RECEIPT_SUPPORT = [
    DeLegalForm.Stiftung,
    DeLegalForm.KoerperschaftDesOeffentlichenRechts,
];
const isDeLegalFormEligibleForReceipt = (legalForm) => !legalForm || !exports.DE_LEGAL_FORMS_WITHOUT_RECEIPT_SUPPORT.includes(legalForm);
exports.isDeLegalFormEligibleForReceipt = isDeLegalFormEligibleForReceipt;
const hasDeReceiptFields = (fields) => Boolean(fields.deTaxNumber &&
    fields.deTaxOffice &&
    fields.deExemptionCertificateDate &&
    fields.deSignatoryName &&
    fields.deCharitablePurpose &&
    fields.deTaxOfficeNotifiedAtUtc);
exports.hasDeReceiptFields = hasDeReceiptFields;
exports.DE_SIGNATORY_NAME_MAX_LENGTH = 120;
// Longer cap: the purpose must match the Freistellungsbescheid word for word, and the receipt prints it twice.
exports.DE_CHARITABLE_PURPOSE_MAX_LENGTH = 300;
const isDeReceiptFreeTextValid = (value, maxLength) => {
    if (!value) {
        return true;
    }
    return value.trim().length <= maxLength;
};
exports.isDeReceiptFreeTextValid = isDeReceiptFreeTextValid;
const getDeTaxOfficeDisplayName = (value) => (value ?? "").trim().replace(/^finanzamt\s+/i, "");
exports.getDeTaxOfficeDisplayName = getDeTaxOfficeDisplayName;
const areDeTaxExemptionFieldsRequired = (type) => type === enums_1.OrganizationType.Charity;
exports.areDeTaxExemptionFieldsRequired = areDeTaxExemptionFieldsRequired;
const areDeFiscalFieldsFormatValid = (country, fields) => {
    if (!(0, exports.usesDeFiscalFields)(country)) {
        return true;
    }
    return ((0, exports.isDeSteuernummerValid)(fields.deTaxNumber) &&
        (0, exports.isDeFinanzamtValid)(fields.deTaxOffice) &&
        (0, exports.isDeExemptionCertificateDateValid)(fields.deExemptionCertificateDate));
};
exports.areDeFiscalFieldsFormatValid = areDeFiscalFieldsFormatValid;
exports.DE_ZER_EIN_BN_PREFIX = "ZER-";
const isDeZerIdValid = (zerId) => /^\d{1,12}$/.test(zerId ?? "");
exports.isDeZerIdValid = isDeZerIdValid;
const toDeZerEinBn = (zerId) => `${exports.DE_ZER_EIN_BN_PREFIX}${zerId}`;
exports.toDeZerEinBn = toDeZerEinBn;
const getDeZerIdFromEinBn = (einBn) => {
    const zerId = einBn?.startsWith(exports.DE_ZER_EIN_BN_PREFIX) ? einBn.slice(exports.DE_ZER_EIN_BN_PREFIX.length) : null;
    return (0, exports.isDeZerIdValid)(zerId) ? zerId : null;
};
exports.getDeZerIdFromEinBn = getDeZerIdFromEinBn;
